// src/api/features/activity-logs/queries.ts

import { useQuery } from "@tanstack/react-query";
import {
  adminListActivityLogs,
  adminListUserActivitySessions,
} from "./api";
import type { ActivityLogListQuery } from "./types";

export function useAdminActivityLogs(query: ActivityLogListQuery = {}) {
  return useQuery({
    queryKey: ["activity-logs", "list", query],
    queryFn: () => adminListActivityLogs(query),
    staleTime: 10_000,
  });
}

export function useAdminUserActivitySessions(
  userId: number | undefined,
  page = 1,
  limit = 50
) {
  return useQuery({
    queryKey: ["activity-logs", "sessions", userId, page, limit],
    queryFn: () => adminListUserActivitySessions(userId as number, page, limit),
    enabled: Boolean(userId),
    staleTime: 10_000,
  });
}
